import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { Skin } from '@core/interfaces/skin.interface';
import { BalanceIconComponent } from '@core/components/balance-icon/balance-icon.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { SkinsRowComponent } from '@old-app/components/skins-row/skins-row.component';

@Component({
  selector: 'app-coinflip-win-notification',
  standalone: true,
  imports: [DecimalPipe, BalanceIconComponent, SvgIconComponent, SkinsRowComponent],
  templateUrl: './coinflip-win-notification.component.html',
  styleUrl: './coinflip-win-notification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoinflipWinNotificationComponent {
  readonly skins = input.required<Skin[]>();
  readonly totalValue = input.required<number>();

  readonly close = output<void>();
  readonly acceptWinnings = output<void>();

  onClose(): void {
    this.close.emit();
  }

  onAcceptWinnings(): void {
    this.acceptWinnings.emit();
  }
}
